import { resolveSetOptions } from './set-variants.mjs';
import { enhanceOfferChoices } from './offer-choices.mjs';
import { initializeAddonPreview } from './product-addon-preview.mjs';

/** Optional complements share the main product's native purchase button and variant. */
export const initializeProductAddons = (form, $, config, lockScroll) => {
    const section = form?.closest('[data-product-page]')?.querySelector('[data-product-addons]');
    if (!section) return null;
    const rows = [...section.querySelectorAll('[data-addon]')].map((node) => {
        const photo = node.querySelector('[data-addon-image] img');
        return {
            node, toggle: node.querySelector('[data-addon-toggle]'),
            selects: [...node.querySelectorAll('[data-addon-attribute]')],
            initialPrice: node.querySelector('[data-addon-price]').innerHTML,
            choices: JSON.parse(node.querySelector('[data-addon-data]').textContent),
            controls: enhanceOfferChoices(node, config.assets, '[data-addon-attribute]'),
            error: node.querySelector('[data-addon-error]'), invalid: false,
            photo, initialImage: photo && { src: photo.getAttribute('src'), srcset: photo.getAttribute('srcset') || '' },
        };
    });
    const base = Number(section.dataset.mainPrice);
    let mainPrice = base;
    let mainResolved = !form.classList.contains('variations_form') || Number(form.querySelector('[name="variation_id"]')?.value) > 0;
    const formatter = new Intl.NumberFormat(section.dataset.locale, {
        style: 'currency', currency: section.dataset.currency,
        minimumFractionDigits: Number(section.dataset.decimals), maximumFractionDigits: Number(section.dataset.decimals),
    });
    const refresh = () => {
        let total = mainPrice; let count = 0;
        let unresolved = !mainResolved;
        rows.forEach((row) => {
            const attributes = row.choices.attributes.map((attribute) => ({ ...attribute, options: attribute.options.map((option) => option.value) }));
            row.result = resolveSetOptions(row.choices.variants, attributes, Object.fromEntries(row.selects.map((select) => [select.dataset.addonAttribute, select.value])));
            row.selects.forEach((select) => {
                [...select.options].forEach((option) => { option.disabled = !!option.value && !row.result.available[select.dataset.addonAttribute].includes(option.value); });
                select.value = row.result.selections[select.dataset.addonAttribute];
                select.disabled = !row.toggle.checked;
                select.required = false; // The visible swatches receive validation and focus.
            });
            const options = row.node.querySelector('[data-addon-options]');
            if (options) options.hidden = !row.toggle.checked;
            row.node.classList.toggle('is-selected', row.toggle.checked);
            row.invalid = row.invalid && row.toggle.checked && !row.result.variant;
            row.node.classList.toggle('is-invalid', row.invalid);
            row.error.hidden = !row.invalid;
            row.controls.sync();
            row.controls.setError(row.invalid ? row.error.id : null);
            row.node.querySelector('[data-addon-price]').innerHTML = row.result.variant?.offer_html ?? row.initialPrice;
            const preview = row.choices.variants.find((variant) => Object.entries(row.result.selections).every(([name, value]) => !value || !variant.attributes[name] || variant.attributes[name] === value));
            const image = Object.values(row.result.selections).some(Boolean) && preview?.image?.src ? preview.image : row.initialImage;
            row.previewVariantId = Object.values(row.result.selections).some(Boolean) ? preview?.id : null;
            if (row.photo && image?.src) { row.photo.src = image.src; row.photo.srcset = image.srcset || ''; }
            if (row.toggle.checked) {
                count += 1;
                unresolved ||= !row.result.variant;
                total += row.result.variant?.price ?? Math.min(...row.choices.variants.map((variant) => variant.price));
            }
        });
        section.querySelector('[data-addon-summary]').hidden = !count;
        section.querySelector('[data-addon-total]').textContent = `${unresolved ? `${section.dataset.fromLabel} ` : ''}${formatter.format(total)}`;
    };
    section.addEventListener('change', refresh);
    $(form).on('found_variation.ovaliaAddons show_variation.ovaliaAddons', (_event, variation) => { mainPrice = Number(variation.display_price); mainResolved = true; refresh(); })
        .on('reset_data.ovaliaAddons', () => { mainPrice = base; mainResolved = false; refresh(); });
    refresh();
    rows.forEach(row => initializeAddonPreview(row.node, config, () => row.previewVariantId, lockScroll));
    return {
        selected: () => rows.some((row) => row.toggle.checked),
        validate: () => {
            refresh();
            const invalid = rows.find((row) => row.toggle.checked && !row.result.variant);
            if (invalid) { invalid.invalid = true; refresh(); invalid.controls.focusMissing(); return false; }
            return true;
        },
        lock: (locked) => {
            section.inert = locked;
            const button = section.querySelector('[type="submit"]');
            button.disabled = locked;
            if (locked) { button.dataset.state = 'loading'; button.setAttribute('aria-busy', 'true'); }
            else { delete button.dataset.state; button.removeAttribute('aria-busy'); }
        },
    };
};
